/*
 * = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = =
 *
 * File: operatorLink.ts
 * Project: sites
 * Created Date: Fr Aug 2024
 * Author: Fabio Capelletti
 *
 * Last Modified: Fri Aug 30 2024
 * Modified By: Fabio Capelletti
 *
 * Copyright (c) 2024 Naar Tour Operator spa
 *
 * HISTORY:
 * Date    	By	Comments
 * --------	---	---------------------------------------------------------
 */

import { EOperatore } from "nr-common";

export class OperatorLink {
	idOperator: EOperatore;
	name: string;

    public get link() : string {
        switch(this.idOperator) {
            case EOperatore.Naar:
                return 'https://www.naar.com';
            case EOperatore.NaarFrance:
                return 'https://fr.naar.com';
            case EOperatore.NaarGermany:
                return 'https://de.naar.com';
            case EOperatore.NaarBenelux:
                return 'https://be.naar.com';
            case EOperatore.NaarSwiss:
                return 'https://ch.naar.com';
            default:
                return 'https://www.naar.com';
        }
    }


	constructor(idOperator: EOperatore, name: string = '') {
		this.idOperator = idOperator;
		this.name = name;
	}
}

